var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.needsMoreInfo ? "border border-primary" : "",
        "card text-center dossier-collapse"
      ]
    },
    [
      _c(
        "div",
        { staticClass: "card-header", on: { click: _vm.toggleCollapse } },
        [
          !_vm.opened
            ? _c("font-awesome-icon", {
                staticClass: "text-primary card-arrow float-left",
                attrs: { icon: ["far", "chevron-down"] }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.opened
            ? _c("font-awesome-icon", {
                staticClass: "text-primary card-arrow float-left",
                attrs: { icon: ["far", "chevron-up"] }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", { staticClass: "float-left mr-2" }, [
            _vm._v("Wijzigingen\n      "),
            _c("span", { staticClass: "text-muted font-italic" }, [
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v("(" + _vm._s(_vm.date) + ")")
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.status === "206"
            ? _c(
                "span",
                { staticClass: "badge badge-primary float-right hr-more-info" },
                [
                  _c("font-awesome-icon", {
                    staticClass: "float-left mr-1",
                    attrs: { icon: ["fad", "exclamation"] }
                  }),
                  _vm._v("\n      HR vraagt meer info\n    ")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "102"
            ? _c(
                "span",
                { staticClass: "badge badge-secondary float-right mr-2" },
                [_vm._v("In behandeling")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "202"
            ? _c(
                "span",
                { staticClass: "badge badge-success float-right mr-2" },
                [_vm._v("Goedgekeurd")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.status === "400"
            ? _c(
                "span",
                { staticClass: "badge badge-danger float-right mr-2" },
                [_vm._v("Geweigerd")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.opened,
                expression: "opened"
              }
            ],
            staticClass: "collapse-content"
          },
          [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _vm._t("default"),
                _vm._v(" "),
                _vm.needsMoreInfo
                  ? _c("div", {
                      staticClass: "text-left border-top pt-3 mt-2 container"
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-footer text-center" },
              [
                _vm.needsMoreInfo
                  ? _c(
                      "ehr-button",
                      {
                        staticClass: "w-25 border-top",
                        attrs: {
                          disabled: !_vm.canSubmit,
                          "button-type-class": "btn-success",
                          icon: "download"
                        },
                        on: { click: _vm.onCollapseSubmit }
                      },
                      [_vm._v("Aanvulling versturen")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canCancel
                  ? _c(
                      "div",
                      [
                        _c(
                          "ehr-button",
                          {
                            attrs: {
                              "button-type-class": "btn-danger",
                              icon: "undo"
                            },
                            on: { click: _vm.onCollapseCancel }
                          },
                          [_vm._v("Annuleren")]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }